/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import { Breakpoint } from 'react-socks';

class EditInputHeader extends React.Component {
	constructor(props) {
		super(props);

		this.onTabClick = this.onTabClick.bind(this);

	}

	onTabClick(e) {
		let nextTab = e.currentTarget.dataset.tab,
			routeId = this.props.router.params.routeId,
			inputId = this.props.router.params.inputId,
			url = '/share/automate/detail/:routeID/input/:inputID';

		url = url.replace(':routeID', routeId);
		url = url.replace(':inputID', inputId);

		if (nextTab === 'status') {
			this.props.router.navigate(url + "/status");
		} else if (nextTab === 'medic') {
			this.props.router.navigate(url + "/medic");
		} else {
			this.props.router.navigate(url);
		}

	}

	render() {
		let settingsClass = classnames('editor-title-tab',{
				'tab-active': (this.props.activeTab === 'settings' || this.props.activeTab === '') ? true : false
			}),
			statusClass = classnames('editor-title-tab', {
				'tab-active': (this.props.activeTab === 'status') ? true : false
			}),
			medicClass = classnames('editor-title-tab', {
				'tab-active': (this.props.activeTab === 'medic') ? true : false
			}),
			linkDestination = '/share/automate',
			params = {},
			tabs = null,
			Icon = IconFactory[ConstantMixin.getIconIndexByCode(this.props.inputType)];

		if (this.props.app.flags.routeViewType === 0) {
			linkDestination = "/share/automate/detail/" + this.props.router.params.routeId;
		} else if (this.props.app.flags.routeViewType === 2) {
			// There's not a routeViewType == 2, just used as a shortcut for curate
			linkDestination = "/share/curate/feeds/list";
		}

		if (this.props.statusOnly) {
			tabs = (
				<div className="editor-title-tabs">
					<div className='editor-title-tab tab-active' data-tab="status">
						<i className="fa fa-history"></i> Feed History
					</div>
				</div>
			);
		} else {
			tabs = (
				<div className="editor-title-tabs">
					<div className={settingsClass} onClick={this.onTabClick} data-tab="settings" role="button" aria-label="settings">
						<i className="fa fa-cog"></i> Settings
					</div>
					<div className={statusClass} onClick={this.onTabClick} data-tab="status" role="button" aria-label="feed history">
						<i className="fa fa-history"></i> Feed History
					</div>
					<div className={medicClass} onClick={this.onTabClick} data-tab="medic" role="button" aria-label="feed medic">
						<i className="fa fa-stethoscope"></i> Medic
					</div>
				</div>
			);
		}

		return (
			<div className="editor-control-bar">
				<div className="editor-flex-wrapper">
					<span className="editor-title label-left padded">
						<Link to={linkDestination} className="breadcrumb">
							{this.props.section}
						</Link>
					</span>
					<i className="fa fa-angle-right editor-title-icon"></i>
					<span className="editor-title label-left single-line">
						<span className="va-helper"></span>
						<Icon />
						{this.props.action}
					</span>
					<Breakpoint desktop only>
						{tabs}
					</Breakpoint>
				</div>
				<Breakpoint mobile only>
					<div className="mobile-feed-functions">
						{tabs}
					</div>
				</Breakpoint>
			</div>
		);
	}

};

EditInputHeader.displayName = "EditInputHeader";

EditInputHeader.propTypes = {
	routeViewType: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	section: PropTypes.string,
	action: PropTypes.string,
	activeTab: PropTypes.string,
	statusOnly: PropTypes.bool,
	inputType: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	])
};

EditInputHeader.defaultProps = {
	routeViewType: 0,
	section: '',
	action: '',
	activeTab: '',
	statusOnly: false
};

export default EditInputHeader;
